<script setup lang="ts">
import SmsTypeBillingEditor from './SmsTypeBillingEditor.vue';
import type { AggregatorSmsTypeMap } from '../../api/types';

defineProps<{
  modelValue: AggregatorSmsTypeMap | undefined | null;
}>();
defineEmits<{
  (e: 'update:modelValue', v: AggregatorSmsTypeMap): void;
}>();
</script>

<template>
  <SmsTypeBillingEditor :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" />
</template>
